import { render, staticRenderFns } from "./Ccoursetree.vue?vue&type=template&id=3ffa2fbc&"
import script from "./Ccoursetree.vue?vue&type=script&lang=js&"
export * from "./Ccoursetree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports